const GLOBAL_RECRUITING_APPLICATION_CREATE = 'RECRUITING_APPLICATION_CREATE';

export default GLOBAL_RECRUITING_APPLICATION_CREATE;
